//
// Depot.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./DepotConfiguration";
import "./warnings/TransportWarning";
import "../models/local/DepotStatus";
import "./ActivitiesManager";
import "./CASManager";
import "./CollectionsManager";
import "./ConnectionManager";
import "./FolderManager";
import "./FavoritesManager";
import "./HistoryManager";
import "./ReportManager";
import "./InsightManager";
import "./SASDriveFileManager";
import "./SubscribedFoldersManager";
import "./ReportViewerNLUManager";
import "./SharedItemManager";
import "./TextTemplatesManager";
import "./ThumbnailManager";
import "./DownloadManager";
import "./MuxManager";
import "../models/local/Connection";
import "./Voucher";
import "../models/local/Report";
import "../models/local/SASDriveFile";
import "../models/local/Insight";
import "../models/local/SubscribedFolder";

var Depot = createModule("transport::Depot", [], EventDispatcher, [
    {
        DEPOT_CONNECTION_CHANGED: 60064,
        DEPOT_INSIGHTS_SYNC_FAILURE: 60085,
        DEPOT_CONNECTION_ESRI_PORTAL_BAD_CREDENTIALS: 60076,
        DEPOT_SHAREDWITHME_CHANGED: 60093,
        DEPOT_CONNECTION_ESRI_DISABLED: 60074,
        DEPOT_CONNECTION_ESRI_PORTAL_HAS_TOKEN: 60075,
        DEPOT_RESUMED: 60061,
        DEPOT_CONNECTION_REQUIRES_AUTHENTICATION: 60069,
        DEPOT_CONNECTION_SERVER_VERSION_NOT_SUPPORTED: 60081,
        DEPOT_CONNECTION_ESRI_NO_CAPABILITY: 60072,
        DEPOT_REPORT_SCHEMA_CHECK_COMPLETE: 60098,
        DEPOT_BUSY: 60058,
        DEPOT_CONNECTION_AUTHENTICATION_FAILED: 60065,
        DEPOT_IDLE: 60059,
        DEPOT_DOWNLOAD_SASDRIVE_FILE_FAILURE: 60091,
        DEPOT_SYNC_SASDRIVE_FILES_COMPLETED: 60094,
        DEPOT_FAVORITES_CHANGED: 60082,
        DEPOT_IMPORT_VA_PUBLISHED_REPORT_COMPLETE: 60099,
        DEPOT_DEVICE_CHECK_COMPLETE: 60096,
        DEPOT_CREATE_SAVE_INSIGHT_FAILURE: 60087,
        DEPOT_CONNECTION_OFFLINE_LIMIT_EXCEEDED: 60066,
        DEPOT_CONNECTION_ESRI_SSO_NOT_AVAILABLE: 60080,
        DEPOT_CONNECTION_ESRI_PORTAL_NO_CREDENTIALS: 60077,
        DEPOT_INSIGHTS_SYNC_COMPLETE: 60084,
        DEPOT_CONNECTION_KEEP_ALIVE_COMPLETE: 60068,
        DEPOT_CONNECTION_ESRI_LOGIN_FAILURE: 60070,
        DEPOT_CONNECTION_ESRI_LOGIN_SUCCESS: 60071,
        DEPOT_SHAREDBYME_CHANGED: 60092,
        DEPOT_CONNECTION_ESRI_PORTAL_NOT_REQUIRED: 60078,
        DEPOT_CONNECTION_REMOVED: 60063,
        DEPOT_DOWNLOAD_SASDRIVE_FILE_COMPLETED: 60090,
        DEPOT_IMPORT_VA_PUBLISHED_REPORT_FAILURE: 60100,
        DEPOT_IMPORT_VA_FILE_POST_PROCESSED: 60101,
        DEPOT_CONNECTION_DENYLIST_ALLOWLIST: 60067,
        DEPOT_UPDATE_INSIGHT_COMPLETE: 60088,
        DEPOT_CONNECTION_ADDED: 60062,
        DEPOT_UPDATE_INSIGHT_FAILURE: 60089,
        DEPOT_ACTIVITY_CREATED: 60057,
        DEPOT_CONNECTION_ESRI_NO_CREDENTIALS: 60073,
        DEPOT_HISTORY_CHANGED: 60083,
        DEPOT_CREATE_SAVE_INSIGHT_COMPLETE: 60086,
        DEPOT_SYNC_SASDRIVE_FILES_FAILURE: 60095,
        DEPOT_CONNECTION_ESRI_PORTAL_NOT_AVAILABLE: 60079,
        DEPOT_IMPORT_VA_FILE_NOT_POST_PROCESSED: 60102,
        DEPOT_USER_CHECK_COMPLETE: 60097,
        DEPOT_QUIESCED: 60060,
    },
    ,
    ,
    ,
    {
        removeAllConnections: [1],
        refreshReportFavoriteFlags: [1,1],
        getCASManager: [1,1],
        commit: [1],
        isSubscribeCategory: [2,1],
        getStatus: [4],
        logEmailSent: [1,1,7],
        getCollectedLogs: [[7]],
        restoreAllSharedFromCache: [0],
        isPublishCategory: [2,1],
        quiesceWhenDone: [1],
        getConnectionByDescription: [1,7],
        getReportManager: [1,1],
        getTextTemplatesManager: [1,1],
        getPasscodeTimeout: [5],
        editConnectionDescription: [1,1,7],
        _getAllInsights_v: [[1]],
        shouldUseCatalogSearchViewModels: [2],
        getCollectionsManager: [1,1],
        checkForFileUpdatesAndDownload: [0],
        _getAllInsights_o: [[1],1],
        refreshAllFavorites: [1,1],
        simulateReportDownloadsFailed: [0],
        guessConnectionScheme: [1,7],
        getReportViewerNLUManager: [1,1],
        _getConnection_snsb: [1,7,4,7,2],
        getInsightManager: [1,1],
        _getReportForInsight_s: [1,7],
        isDebugEnabled: [2],
        _getConnection_s: [1,7],
        addLocalConnection: [1],
        _getAllFiles_o: [[1],1],
        removeReport: [1,1],
        _getFile_os: [1,1,7],
        _getAllFiles_v: [[1]],
        setUseHighContrastReportStyle: [0,2],
        changeAutoUpdateFrequency: [0,4],
        getPasscodeAttempts: [4],
        _getAllReportsForInsights_v: [[1]],
        getLocalConnection: [1,2],
        removeAllReports: [1],
        startCollectingLogs: [0,4,4],
        resume: [1],
        _getSubscribedFolder_o: [1,1],
        getSASDriveFileManager: [1,1],
        _getAllReportsForInsights_o: [[1],1],
        getConnectionManager: [1,1],
        getDownloadManager: [1],
        _getSubscribedReport_os: [1,1,7],
        refreshSharedItemsWithMe: [1,1],
        _getSubscribedFolder_s: [1,7],
        _getSubscribedFolder_os: [1,1,7],
        refreshHistory: [1,1],
        _getFile_s: [1,7],
        shouldUsePkceForOauth2: [2],
        stopCollectingLogs: [0],
        getSharedItemManager: [1,1],
        copyFeatureFlagsToMultiverse: [4,1],
        getAllPublishedReports: [[1]],
        getFolderManager: [1,1],
        getSubscribedFoldersManager: [1,1],
        removeSubscribedFolder: [1,1],
        _getSubscribedReport_s: [1,7],
        addConnection: [1,1],
        isInsightCategory: [2,1],
        getFavoritesManager: [1,1],
        _getAllReports_v: [[1]],
        _getReportForInsight_os: [1,1,7],
        _getAllReports_o: [[1],1],
        releaseDelayedEvents: [0],
        getDepotConfiguration: [1],
        editConnectionPassword: [1,1,7],
        shutdown: [1],
        getConnections: [[1],7,4],
        _getInsight_os: [1,1,7],
        _getAllSubscribedReports_v: [[1]],
        getActivitiesManager: [1,1],
        _getAllPortfolioReports_v: [[1]],
        refreshRootFavorites: [1,1],
        getNextUniqueLocalReportLabel: [7,7],
        getLocalReportWithLabel: [1,7],
        setDebug: [0,2],
        _getAllPortfolioReports_o: [[1],1],
        isPasscodeRequired: [2],
        _getDepotReport_s: [1,7],
        _getAllSubscribedReports_o: [[1],1],
        renameLocalReport: [0,1,7],
        _getInsight_s: [1,7],
        restore: [2],
        getAllConnections: [[1]],
        getMuxManager: [1],
        _getDepotReport_os: [1,1,7],
        quiesce: [1],
        getHistoryManager: [1,1],
        getThumbnailManager: [1,1],
        refreshSharedItemsByMe: [1,1],
        verifyConnection: [1,1],
        removeConnection: [1,1],
        refreshCollections: [1,1],
        updateTimers: [0],
        getAllServerConnections: [[1]],
    },
    {
        _create: [4,1],
        areTransportDebugFeaturesEnabled: [2],
        getDefaultConnectionDescription: [7,7,7],
        getDefaultGuestConnectionDescription: [7,7],
    },
    ["getReportForInsight","getAllSubscribedReports","getSubscribedFolder","getAllReportsForInsights","getAllInsights","getInsight","getAllPortfolioReports","getDepotReport","getFile","getAllReports","getConnection","getAllFiles","getSubscribedReport"],
]);
export default Depot;
